import React, { Component } from "react"
import get from "lodash.get"
import { root } from "../services/Globals"
import { Subscribe } from "unstated"
import { CampaignContainer } from "./CampaignContainer"
import { CampaignsContainer } from "./CampaignsContainer"
import isEqual from "deep-equal"
import Panel, { Content, CommandBar, Command } from "../Panel"
import { Form } from "semantic-ui-react"
import Select from "../Select"
import Button from "../TextButton"

const formatDate = utcDateTime => {
  return new Date(utcDateTime).toLocaleDateString(`sv-SE`, {
    year: `numeric`,
    month: `2-digit`,
    day: `2-digit`,
  })
}

const formatTime = utcDateTime => {
  return new Date(utcDateTime).toLocaleTimeString(`sv-SE`, {
    hour: `2-digit`,
    minute: `2-digit`,
  })
}

const STATUS = {
  Active: `Active`,
  Inactive: `InActive`,
  Draft: `Draft`,
}

const initialState = {
  name: undefined,
  title: undefined,
  description: undefined,
  startTimeUtc: new Date(Date.now()).toISOString(),
  endTimeUtc: new Date(Date.now()).toISOString(),
  code: undefined,
  status: STATUS.Draft,
  prePlanPeriodDays: undefined,
  prePlan: {
    id: undefined,
  },
  plan: {
    id: undefined,
  },
  planTitle: undefined,
  amount: undefined,
  stripeCouponId: undefined,
  choir: {
    id: undefined,
  },
}

class Campaign extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...initialState,
      name: (props.location.state && props.location.state.name) || ``,
    }
  }

  render = () => {
    const campaign = this.props.campaign || {}

    return (
      <Panel
        title={
          !this.props.campaignId
            ? `New campaign`
            : this.props.isFetching
            ? `Loading campaign...`
            : this.state.name
            ? `Edit campaign: ${ this.state.name }`
            : `Campaign`
        }
        onClose={() =>
          this.props.history.push(
            this.props.returnTo ||
              `/campaigns${
                this.props.location.search ? this.props.location.search : ``
              }`
          )
        }
      >
        <CommandBar>
          {this.props.campaignId && (
            <Command.Delete
              onClick={() => {
                const deleteNotification = new root.wav.Notification({
                  text: `<h4 class="ui header"><i aria-hidden="true" class="trash icon"></i><div class="content">You are about to delete this campaign permanently, delete this campaign?</div></h4>`,
                  buttons: [
                    root.wav.Notification.button(
                      `Yes`,
                      `ui compact button`,
                      () => {
                        this.props.deleteCampaign(this.state.id).then(id => {
                          deleteNotification.close()
                          this.props.removeCampaignFromCampaigns(id)
                          this.props.history.push(
                            this.props.returnTo ||
                              `/campaigns${
                                this.props.location.search
                                  ? this.props.location.search
                                  : ``
                              }`
                          )
                        })
                      }
                    ),
                    root.wav.Notification.button(
                      `No`,
                      `ui compact button`,
                      () => {
                        deleteNotification.close()
                      }
                    ),
                  ],
                  theme: `semanticui`,
                  modal: true,
                }).show()
              }}
            />
          )}
          <Command.Save
            disabled={isEqual(this.state, campaign)}
            onClick={() => {
              this.props[this.state.id ? `updateCampaign` : `createCampaign`]({
                ...this.state,
                ...(this.state.amount
                  ? {
                      amount: parseFloat(
                        this.state.amount.toString().replace(/,/g, `.`),
                        10
                      ),
                    }
                  : {}),
              }).then(campaign => {
                this.props.updateCampaignInCampaigns(campaign)
                this.props.campaignId
                  ? this.props.fetchCampaign(campaign.id)
                  : this.props.history.push(
                      `/campaigns/${ campaign.id }` + this.props.location.search
                    )
              })
            }}
          />
        </CommandBar>
        <Content
          loading={
            this.props.isFetching ||
            this.props.isDeleting ||
            this.props.isSaving
          }
        >
          <Form autoComplete="off" style={{ marginBottom: `2rem` }}>
            <Form.Input
              label="Name"
              name="name"
              value={this.state.name}
              onChange={this.handleInputChange}
            />

            <Form.Input
              label="Title"
              name="title"
              value={this.state.title || ``}
              onChange={this.handleInputChange}
            />

            <Form.TextArea
              label="Description"
              name="description"
              value={this.state.description || ``}
              onChange={this.handleInputChange}
            />

            <Form.Input
              label="Code"
              name="code"
              type="text"
              value={this.state.code || ``}
              onChange={this.handleInputChange}
            />

            <Form.Input
              label="Stripe coupon ID"
              name="stripeCouponId"
              value={this.state.stripeCouponId || ``}
              onChange={this.handleInputChange}
            />

            <Form.Field>
              <label
                style={{ display: `flex`, justifyContent: `space-between` }}
              >
                Pre-plan{` `}
                <Button onClick={this.clearPrePlan}>Clear selection</Button>
              </label>
              <Select
                fluid
                selectOnBlur={false}
                name="prePlan"
                url="/plans"
                value={get(this.state, `prePlan.id`, undefined)}
                onChange={this.handlePrePlanChange}
              />
            </Form.Field>

            <Form.Input
              label="Pre-plan period (days)"
              name="prePlanPeriodDays"
              type="number"
              value={this.state.prePlanPeriodDays || 0}
              onChange={this.handleInputChange}
            />

            <Form.Field>
              <label>Plans</label>
              <Select
                fluid
                selectOnBlur={false}
                multiple
                name="plans"
                url="/plans"
                onChange={this.handlePlansChange}
                value={get(this.state, `plans`, [])}
              />
            </Form.Field>

            <Form.Input
              label="Override plan title"
              name="planTitle"
              type="text"
              value={this.state.planTitle || ``}
              onChange={this.handleInputChange}
            />

            <Form.Input
              label="Amount"
              name="amount"
              type="text"
              value={this.state.amount || ``}
              onChange={this.handleInputChange}
            />

            <Form.Field>
              <label
                style={{ display: `flex`, justifyContent: `space-between` }}
              >
                Choir <Button onClick={this.clearChoir}>Clear selection</Button>
              </label>
              <Select
                fluid
                selectOnBlur={false}
                name="choir"
                url="/choirs"
                value={get(this.state, `choir.id`, undefined)}
                onChange={this.handleChoirChange}
              />
            </Form.Field>

            <Form.Group>
              <Form.Input
                label="Start date"
                name="startDate"
                type="date"
                value={formatDate(this.state.startTimeUtc)}
                onChange={this.handleDateInputChange}
              />

              <Form.Input
                label="Start time"
                name="startTime"
                type="time"
                value={formatTime(this.state.startTimeUtc)}
                onChange={this.handleTimeInputChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Input
                label="End date"
                name="endDate"
                type="date"
                value={formatDate(this.state.endTimeUtc)}
                onChange={this.handleDateInputChange}
              />

              <Form.Input
                label="End time"
                name="endTime"
                type="time"
                value={formatTime(this.state.endTimeUtc)}
                onChange={this.handleTimeInputChange}
              />
            </Form.Group>

            {this.state.id && (
              <Form.Select
                label="Status"
                name="status"
                options={Object.entries(STATUS).map(([ key, value ]) => ({
                  value,
                  text: key,
                }))}
                value={this.state.status || ``}
                onChange={this.handleSelectChange}
              />
            )}

            {this.state.createdUtc && (
              <Form.Field>
                <label>Created</label>
                <p>
                  {new Date(this.state.createdUtc).toLocaleString(
                    navigator.language
                  )}
                </p>
              </Form.Field>
            )}

            {this.state.updatedUtc && (
              <Form.Field>
                <label>Updated</label>
                <p>
                  {new Date(this.state.updatedUtc).toLocaleString(
                    navigator.language
                  )}
                </p>
              </Form.Field>
            )}
          </Form>
        </Content>
      </Panel>
    )
  }

  componentDidMount = () => {
    this.props.match.params.campaignId &&
      this.props
        .fetchCampaign(this.props.match.params.campaignId)
        .then(data => this.setState(data))
  }

  componentDidUpdate = previousProps => {
    if (
      previousProps.campaign.id !== this.props.campaign.id ||
      previousProps.campaign.updatedUtc !== this.props.campaign.updatedUtc
    ) {
      this.setState({
        ...this.props.campaign,
      })
    }
  }

  handleInputChange = ({ target: { name, value, type } }) => {
    process.env.NODE_ENV === `development` &&
      console.log(`Campaign:handleInputChange`, name, value)

    this.setState(previousState => ({
      ...previousState,
      [name]: type === `number` ? parseInt(value) : value,
      // [name]: value,
    }))
  }

  handleSelectChange = (event, { name, value }) => {
    process.env.NODE_ENV === `development` &&
      console.log(`Campaign:handleSelectChange`, name, value)

    this.setState(previousState => ({
      ...previousState,
      [name]: value,
    }))
  }

  handleDateInputChange = (event, { name, value }) => {
    process.env.NODE_ENV === `development` &&
      console.log(`Campaign:handleDateInputChange`, name, value)

    // value format:
    // 2018-08-26

    const targetTimeUtc =
      name.indexOf(`start`) > -1 ? `startTimeUtc` : `endTimeUtc`

    const [ year, month, day ] = (
      value || formatDate(new Date(Date.now()).toISOString())
    ).split(`-`)

    this.setState(previousState => {
      const newDate = new Date(previousState[targetTimeUtc])

      newDate.setUTCFullYear(year)
      newDate.setUTCMonth(month - 1)
      newDate.setUTCDate(day)

      return {
        ...previousState,
        [targetTimeUtc]: newDate.toISOString(),
      }
    })
  }

  handleTimeInputChange = (event, { name, value }) => {
    process.env.NODE_ENV === `development` &&
      console.log(`Campaign:handleTimeInputChange`, name, value)

    // value format
    // 12:30

    const targetTimeUtc =
      name.indexOf(`start`) > -1 ? `startTimeUtc` : `endTimeUtc`

    const [ hours, minutes ] = (
      value || formatTime(new Date(Date.now()).toISOString())
    ).split(`:`)

    this.setState(previousState => {
      const newDate = new Date(previousState[targetTimeUtc])

      newDate.setHours(hours)
      newDate.setMinutes(minutes)

      return {
        ...previousState,
        [targetTimeUtc]: newDate.toISOString(),
      }
    })
  }

  handlePrePlanChange = plan => {
    process.env.NODE_ENV === `development` &&
      console.log(`Campaign:handlePrePlanChange`, plan)

    this.setState(previousState => ({
      ...previousState,
      prePlan: plan
        ? {
            id: plan.id,
          }
        : { prePlan: { id: undefined } },
    }))
  }

  handlePlansChange = plans => {
    process.env.NODE_ENV === `development` &&
      console.log(`Campaign:handlePlansChange`, plans)

    this.setState(previousState => ({
      ...previousState,
      plans: plans,
    }))
  }

  handleChoirChange = choir => {
    process.env.NODE_ENV === `development` &&
      console.log(`Campaign:handleChoirChange`, choir)

    this.setState(previousState => ({
      ...previousState,
      choir: choir
        ? {
            id: choir.id,
          }
        : { choir: { id: undefined } },
    }))
  }

  clearPrePlan = event => {
    event.preventDefault()
    event.stopPropagation()

    this.setState(previousState => ({
      ...previousState,
      prePlan: { id: undefined },
    }))
  }

  clearChoir = event => {
    event.preventDefault()
    event.stopPropagation()

    this.setState(previousState => ({
      ...previousState,
      choir: { id: undefined },
    }))
  }
}

export default props => {
  const campaignId = props.match.params.campaignId

  return (
    <Subscribe to={[ CampaignContainer, CampaignsContainer ]}>
      {(
        { state, ...actions },
        { state: campaignsState, ...campaignsActions }
      ) => {
        return (
          <Campaign
            key={campaignId}
            campaignId={campaignId}
            {...campaignsActions}
            {...props}
            {...state}
            {...actions}
          />
        )
      }}
    </Subscribe>
  )
}
